import { render, staticRenderFns } from "./AppliedProduct.vue?vue&type=template&id=1805454c&scoped=true&"
import script from "./AppliedProduct.vue?vue&type=script&lang=ts&"
export * from "./AppliedProduct.vue?vue&type=script&lang=ts&"
import style0 from "./AppliedProduct.vue?vue&type=style&index=0&id=1805454c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1805454c",
  null
  
)

export default component.exports